<template>
    <span>
        <span v-show="enabled">
            <select class="layuiselect" >
                <slot></slot>
            </select>
        </span>
        <span v-show="!enabled">
            <select class="layuiselect-disabled" disabled="disabled">
            </select>
        </span>
    </span>
</template>

<script>

export default {
    name: 'LayuiSelect',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-select-' + window.uuid();
            },
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        lazy : {
            type: Boolean,
            default: ()=> {
                return false;
            }
        },
        _model: {
            default: null,
            required: false
        },
        initValue: {
            required: false,
            type: String
        },
        initData: {
            type: Array,
            default: () => {
                return []
            }
        },
        textField: {
            default: "text",
            type: String
        },
        valueField: {
            default: "value",
            type: String
        },
        enableSearch: {
            default: false,
            type: Boolean
        },
        // 配置了 tableName 那么slot插槽就不起作用
        tableName: {
            type: String,
            default: ''
        },
        queryCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        showNullOption : {
            type: Boolean,
            default: false
        },
        nullText: {
            type: String,
            default: '--请选择--'
        },
        selectFields: {
            type: String,
            default: '',
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        renderText: {
            type: Function,
            default: (row, textField)=> {
                return row[textField];
            }
        },
        cacheCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            id : null,
            el : null,
            isloaded: false,
            selectData: null, //当前选中的值
            condition: {},
            data: [],
        }
    },
    methods: {
        getData() {
            return this.data;
        },
        getDataByValue(value) {
            return this.data.find((obj)=>{
                if(obj[this.valueField] == value) {
                    return obj;
                }
            });
        },
        getSelectData() {
            return this.selectData;
        },
        setData(data) {
            this.data = data;
            this.load();
        },
        clearValue(){
             this.$emit('_modelEvent', '');
        },
        // 根据给定的记录，选中select
        // 该方法不应该，也不会修改v-model绑定的值
        selectValue(selectData) {
            var value = null;
            // null 作为空值来处理，防止报错
            if (selectData == null) {
                selectData = '';
            }
            if(typeof selectData === 'object') {
                value = selectData[this.valueField];
            } else {
                value = selectData;
            }
            this.selectData = this.getDataByValue(value);
            if(!this.ui_update) {
                this.addSelectClass(this.select, value);
                this.addSelectClass(this.disableSelect, value);
            }
            this.ui_update = false;
        },
        addSelectClass(select, value){
            select.val(value);
            var parent = $("[lay-filter='" + select.attr("lay-filter")+"']").parent();
            parent.find("dd").removeClass("layui-this");
            var item = parent.find("dd[lay-value='" + value + "']");
            item.addClass("layui-this");
            var text = item.text();
            if (value) {
                parent.find("input").val(text);
            } else {
                parent.find("input").attr('placeholder', text);
                parent.find("input").val('');
            }
        },
        // 根据最新的data,刷新select
        load() {
            this.select.children().remove();
            this.disableSelect.children().remove();
            if(!this.data) {
                this.data = [];
            }
            this.data.forEach((item)=> {
                var itemE = ('<option value="' + item[this.valueField] +'">' + this.renderText(item, this.textField) + '</option>');
                this.select.append($(itemE));
                this.disableSelect.append($(itemE));
            });
            this.layui.form.render('select', this.id);
            this.layui.form.render('select', this.disabledId);
            this.layui.form.on('select(' + this.id + ')', (data) => {
                this.ui_update = true;
                // 通知v-model修改所绑定的值, 该事件会修改this._model的值,以及v-model所绑定的值
                let selectData = this.getDataByValue(data.value);
                this.$emit('_modelEvent', data.value);
                this.$emit('selectChange', selectData);
                this.addSelectClass(this.disableSelect, data.value);
            });

        },
        refreshAsyncData(cb){
            this.isloaded = false;
            if(this._cacheCondition && Object.keys(this._cacheCondition).length > 0) {
                this.api.cache_get(
                            this.tableName,  this._cacheCondition.CACHE_KEY,  this._cacheCondition.CACHE_VALUE,
                            this.requestUniqueId
                    ).then(response => {
                    var results = response.result;
                    this.data = results;
                    if(this.showNullOption) {
                        var nullOption = {};
                        nullOption[this.textField] = this.nullText;
                        nullOption[this.valueField] = '';
                        this.data.unshift(nullOption);
                    }
                    this.load();
                    this.isloaded = true;
                    this.afterLoad();
                    if(cb) cb(results);
                });
            } else {
                this.condition = this.queryCondition;
                this.api.queryList(
                            this.tableName,
                            {p2: this.condition,  p9: this.selectFields, p10: this.sort},
                            this.requestUniqueId
                    ).then(response => {
                    var results = response.result;
                    this.data = results;
                    if(this.showNullOption) {
                        var nullOption = {};
                        nullOption[this.textField] = this.nullText;
                        nullOption[this.valueField] = '';
                        this.data.unshift(nullOption);
                    }
                    this.load();
                    this.isloaded = true;
                    this.afterLoad();
                    if(cb) cb(results);
                });
            }

        },
        afterLoad() {
           // 这时组件加载完了，但是可能外部已经修改了model的值，
           // 如果已经修改了，那么就不用执行initValue的逻辑了，因为这个时候initValue的值已经不算是最新的值了
            if(this._model) {
                this.selectValue(this._model);
                this.$emit('modelChange',this.selectData);
            } else {
                if(this.initValue) {
                    // 修改v-model绑定的值
                    this.$nextTick(()=> {
                        // 注意$emit这里会触发下面watch监听的_model方法
                        // 是为了给v-model绑定的属性赋值
                        this.$emit('_modelEvent',this.initValue);
                        this.selectData = this.getDataByValue(this.initValue);
                        this.$emit('modelChange',this.selectData);
                    });
                }
            }
            this.handleEnabled();
        },
        handleEnabled() {

        }
    },
    mounted(){
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.disabledId = this.id + "_disabled"
        this.select = element.find(".layuiselect").attr('lay-filter', id);
        if (this.enableSearch) {
            this.select.attr('lay-search','');
        }
        this.disableSelect = element.find(".layuiselect-disabled").attr('lay-filter', this.disabledId);
        if(this.initData && this.initData.length > 0) {
            this.data = this.initData;
            this.load();
            this.isloaded = true;
            this.afterLoad();
        } else if(this.tableName) {
            if(!this.lazy) {
                this.condition = this.queryCondition;
                this._cacheCondition = this.cacheCondition;
                this.refreshAsyncData();
            } else {
                this.load();
            }
        } else {
            var children = this.select.children();
            if(children.length > 0) {
                for(var i = 0 ; i < children.length; i++) {
                    var child = $(children[i]);
                    var value = child.attr('value');
                    var text = child.text();
                    var obj = {};
                    obj[this.valueField] = value;
                    obj[this.textField] = text;
                    this.data.push(obj);
                }
                this.load();
                this.isloaded = true;
                this.afterLoad();
            }
        }
    },
    watch:{
        // 如果组件数据是异步加载的，那么可能会有时间差的问题，
        // 这个时候组件的model或者enabled等其他属性，可能在其他地方已经被修改了
        // 为了简单起见，我们使用为组件添加一个isLoaded属性，只有组件加载完毕了才会执行watch里面的逻辑，
        // 其他地方应该添加额外的判断这些watch可能没来得及执行的时候
        _model(value){
           if(this.isloaded) {
               this.selectValue(value);
           }
        },
        enabled() {
            if(this.isloaded) {
                this.handleEnabled();
            }

        }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/common/LayuiSelect.vue